import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setToken } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    const run = async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        const res = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        window.history.replaceState(null, "", window.location.pathname);
        await setToken(res.data.token);
        navigate("/admin");
      } catch (e) {
        navigate("/login");
      }
    };
    run();
  }, [navigate, setToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] text-muted-foreground gap-2">
      <Loader2 className="w-5 h-5 animate-spin" /> Accesso in corso…
    </div>
  );
};

export default AuthCallback;
